import { User } from '../api';

interface DashboardPageProps {
  user: User | null;
  projectSlug?: string;
  projectName?: string;
  onBack?: () => void;
}

export function DashboardPage({ user, projectSlug, projectName, onBack }: DashboardPageProps) {
  return (
    <div className="page">
      {projectSlug && onBack && (
        <button className="back-button" onClick={onBack}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8l4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          All projects
        </button>
      )}
      <div className="page-header">
        <h1>{projectName || 'Dashboard'}</h1>
        <p className="subtitle">
          {projectSlug
            ? `Results for ${projectName}`
            : `Welcome back, ${user?.first_name || user?.email}`}
        </p>
      </div>

      <div className="dashboard-empty-state">
        <svg
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="dashboard-empty-icon"
        >
          <rect x="8" y="16" width="64" height="48" rx="6" stroke="currentColor" strokeWidth="2.5" />
          <path d="M8 28h64" stroke="currentColor" strokeWidth="2.5" />
          <circle cx="16" cy="22" r="2" fill="currentColor" opacity="0.5" />
          <circle cx="23" cy="22" r="2" fill="currentColor" opacity="0.5" />
          <circle cx="30" cy="22" r="2" fill="currentColor" opacity="0.5" />
          <rect x="18" y="36" width="20" height="3" rx="1.5" fill="currentColor" opacity="0.3" />
          <rect x="18" y="43" width="14" height="3" rx="1.5" fill="currentColor" opacity="0.2" />
          <rect x="18" y="50" width="18" height="3" rx="1.5" fill="currentColor" opacity="0.15" />
          <rect x="48" y="36" width="16" height="18" rx="3" stroke="currentColor" strokeWidth="2" opacity="0.3" />
        </svg>
        <h2 className="dashboard-empty-title">Your results are coming soon...</h2>
        <p className="dashboard-empty-description">
          Once your data is ready, your results and insights will appear right here.
        </p>
      </div>
    </div>
  );
}
